<template>
	<div id="app">
		<!-- Loading Screen -->
		<div v-if="loading" class="loading-wrapper">
			<div class="spinner"></div>
			<p>Loading...</p>
		</div>

		<!-- Main Layout -->
		<div v-else>
			<component :is="layout">
				<router-view />
			</component>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: true
		}
	},
	computed: {
		layout() {
			return "layout-" + (this.$route.meta.layout || "dashboard").toLowerCase();
		}
	},
	watch: {
		// เมื่อมีการเปลี่ยน route ให้โชว์ loading ก่อน
		"$route"(val) {
			console.log('APP', val)
			this.showLoading();
		}
	},
	mounted() {
		// ครั้งแรกที่เปิดหน้า
		this.showLoading();
	},
	methods: {
		showLoading() {
			this.loading = true;
			// จำลองการโหลดข้อมูล 500ms ก่อนซ่อน
			setTimeout(() => {
				this.loading = false;
			}, 500);
		}
	}
}
</script>

<style lang="scss">
.loading-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;
	background: #f9f9f9;
}

.spinner {
	width: 50px;
	height: 50px;
	border: 5px solid #ddd;
	border-top: 5px solid #3f51b5;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>
